import { useEffect, useState } from "react";

export const useCheckList = (
  uniqueFieldName,
  data,
  setData,
  setDefaultData,
  isNested,
  nestFieldName
) => {
  const [checkedAll, setCheckedAll] = useState(false);

  useEffect(() => {
    let checkCount = 0;
    data?.forEach((element) => {
      if (element.checked) {
        checkCount++;
      }
    });
    if (data?.length !== 0 && checkCount === data?.length) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
  }, [data]);

  const handleCheckAll = () => {
    if (checkedAll) {
      const checkedData = data.map((val) => {
        return { ...val, checked: false };
      });
      setData(checkedData);
      setDefaultData(checkedData);
    } else {
      const checkedData = data.map((val) => {
        return { ...val, checked: true };
      });
      setData(checkedData);
      setDefaultData(checkedData);
    }
    setCheckedAll(!checkedAll);
  };

  const checkOneNested = (data, uniqueField, checkCount) => {
    let nestedCheckedData = data?.map((val) => {
      if (val[uniqueFieldName] === uniqueField) {
        if (val.checked) {
          return { ...val, checked: false };
        } else {
          checkCount++;
          return { ...val, checked: true };
        }
      } else if (val?.[nestFieldName]?.length > 0) {
        let { nestedCheckedData, nestedCheckCount } = checkOneNested(
          val?.[nestFieldName],
          uniqueField,
          checkCount
        );
        checkCount = nestedCheckCount;
        return { ...val, [nestFieldName]: nestedCheckedData };
      }
      if (val.checked) {
        checkCount++;
      }
      return val;
    });
    return { nestedCheckedData, nestedCheckCount: checkCount };
  };

  const handleCheckOne = (uniqueField) => {
    let checkCount = 0;
    let checkedData;
    if (isNested) {
      let { nestedCheckedData, nestedCheckCount } = checkOneNested(
        data,
        uniqueField,
        checkCount
      );
      checkedData = nestedCheckedData;
      checkCount = nestedCheckCount;
    } else {
      checkedData = data.map((val) => {
        if (val[uniqueFieldName] === uniqueField) {
          if (val.checked) {
            return { ...val, checked: false };
          } else {
            checkCount++;
            return { ...val, checked: true };
          }
        }
        if (val.checked) {
          checkCount++;
        }
        return val;
      });
    }
    if (checkCount === data.length) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
    setData(checkedData);
    setDefaultData(checkedData);
  };

  return {
    checkedAll,
    handleCheckAll,
    handleCheckOne,
  };
};
